<div class="buttons-container buttons-right button-success">
  <a (click)="successButtonClicked()" class="button has-ripple" [id]="geefMeetid(vraag.button_text)">{{vraag.button_text}}</a>
</div>
